import React from 'react';
import { motion } from 'framer-motion';
import { VideoIcon } from 'lucide-react';
export function CreatorSection() {
  return <section className="relative z-10 bg-transparent px-4 py-8" aria-labelledby="creator-title" data-id="element-126" data-mp="1wzypmha72ty5">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.35
    }} className="mx-auto grid max-w-4xl items-center gap-6 overflow-hidden rounded-[2rem] border border-[#00f0ff]/25 bg-[#120b2a]/85 p-5 shadow-[0_0_32px_rgba(0,240,255,0.12)] md:grid-cols-[220px_1fr] md:p-7" data-id="element-127" data-mp="1j0p7hc2fhprj">
        <div className="mx-auto w-full max-w-[220px] overflow-hidden rounded-full border-2 border-[#c084fc] bg-black shadow-[0_0_24px_rgba(192,132,252,0.35)]" data-id="element-128" data-mp="10ck5oa5c0evd">
          <img src="https://cdn.magicpatterns.com/uploads/8enqmNLiaLBDuvRtfxDXCn/Martin_G._creador_de_neon_flex.webp" alt="Martín G., creador del curso digital de Neon Flex" width={512} height={512} loading="lazy" decoding="async" className="aspect-square h-full w-full object-cover" data-id="element-129" data-mp="qcjksjrtdqp2" />
        </div>

        <div className="text-center md:text-left" data-id="element-130" data-mp="ymoxh2wydfjl">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#ec4899]/30 bg-[#ec4899]/10 px-3 py-1 text-xs font-black tracking-widest text-[#f9a8d4]" data-id="element-131" data-mp="ylds4ynuzzqd">
            <VideoIcon className="h-4 w-4" data-id="element-132" data-mp="6vit2aa78voi" />
            TU INSTRUCTOR
          </div>
          <h2 id="creator-title" className="text-3xl font-black tracking-tight text-white md:text-4xl" data-id="element-133" data-mp="1wz92ff61tys">
            Conocé a <span className="text-[#00f0ff]" data-id="element-134" data-mp="fovuy1q8r7mq">Martín G.</span>
          </h2>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-gray-300 md:text-lg" data-id="element-135" data-mp="awck3cixuqlm">
            Desarrollado por Martín G., creador de Neon Flex Digital. Un curso
            pensado para que cualquier persona pueda aprender el proceso completo
            desde cero.
          </p>
        </div>
      </motion.div>
    </section>;
}